import { DownOutlined } from "@ant-design/icons";
import { Form, Tree } from "antd";
import React, { useEffect, useState } from "react";
import { fn_getAllKeys } from "../../../helpers/loadSeguridad";

export const AccesoUsuarioTree = ({ treeData }) => {
  const form = Form.useFormInstance();
  const accesosusuario = Form.useWatch("accesosusuario", form);
  const [keysExpanded, setKeysExpanded] = useState([]);
  useEffect(() => {
    const allKeys = fn_getAllKeys(treeData);
    setKeysExpanded(allKeys);
  }, [treeData]);
  const onExpand = (keys) => setKeysExpanded(keys);
  const handleCheck = (keysCheckedAcceso) =>
    form.setFieldsValue({ accesosusuario: keysCheckedAcceso });
  return (
    <Tree.DirectoryTree
      checkable
      showLine
      treeData={treeData}
      switcherIcon={<DownOutlined />}
      expandedKeys={keysExpanded}
      checkedKeys={accesosusuario}
      onExpand={onExpand}
      onCheck={handleCheck}
    />
  );
};
